import React from 'react';
import fhirpath from 'fhirpath';
import { PassoExecutado } from '@/models/PassoExecutado';

import { ArtifactFormOverrides } from '@/features/artifacts/components/ArtifactForm/ArtifactForm.types';
import { useArtifactFormConfig } from '@/features/artifacts/hooks/useArtifactFormConfig';

import { useEnterpriseContext } from '@/features/enterprise/contexts/EnterpriseContext';
import CardSolicitacao, {
  CardSolicitacaoProxyProps,
} from '../../CardSolicitacao';
import SolicitacaoList from '..';
import { useSolicitacoesContext } from '../../../providers/SolicitacoesProvider.index';
import CardSharedDevices from '../../CardSharedDevices';
import { SharedDevices } from '../../CardSharedDevices/helpers';

// import { Container } from './styles';
const Form: ArtifactFormOverrides = [
  { name: 'reasonCode', label: 'Indicação clínica', required: true },
  { name: 'bodySite', label: 'Local do Corpo' },
  { name: 'orderDetail', label: 'Observações' },
  { name: 'opmes', label: 'OPME Sugeridos' },
];

const CardProcedimento: React.FC<CardSolicitacaoProxyProps> = ({
  solicitacao,
  ...rest
}) => {
  const form = useArtifactFormConfig('solicitacao-exame', Form);

  const title = React.useMemo(() => {
    return fhirpath.evaluate(
      solicitacao.pedido,
      'ServiceRequest.code.text | ServiceRequest.code.coding.display',
    )[0];
  }, [solicitacao.pedido]);

  const description = React.useMemo(() => {
    const note = fhirpath.evaluate(
      solicitacao.pedido,
      'ServiceRequest.note.text',
    );
    if (note.length) {
      return note[0];
    }

    return '';
  }, [solicitacao.pedido]);

  return (
    <CardSolicitacao
      title={title}
      description={description}
      solicitacao={solicitacao}
      form={form}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
};
interface Props {
  passo: PassoExecutado;
}
const SolicitacaoListProcedimento: React.FC<Props> = ({ passo }) => {
  const { list, changeSharedDevices } = useSolicitacoesContext();
  const [{ mode }] = useEnterpriseContext();

  const handleSharedDevicesChange = React.useCallback(
    (shared: SharedDevices[]) => {
      changeSharedDevices({ source: passo.id, shared });
    },
    [changeSharedDevices, passo],
  );

  const procedimentos = React.useMemo(() => {
    return list({ tipo: 'procedimento', source: passo.id })
      .filter(({ selected }) => selected)
      .map(state => state.solicitacao);
  }, [list, passo]);

  const canEditDevices = React.useMemo(() => {
    return mode !== 'not_integrated' && !passo.executado;
  }, [mode, passo.executado]);

  return (
    <SolicitacaoList
      tipo="procedimento"
      passo={passo}
      CardSolicitacaoComponent={CardProcedimento}
      groupTitle="Selecione os procedimentos que você deseja solicitar no seu prontuário"
      addConfig={{
        title: 'Adicionar procedimento complementar',
      }}
    >
      <CardSharedDevices
        procedimentos={procedimentos}
        onSharedDevicesChange={handleSharedDevicesChange}
        disabled={!canEditDevices}
      />
    </SolicitacaoList>
  );
};

export default SolicitacaoListProcedimento;
